var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-toolbar-title',[_vm._v(" Resurseudgifter ")])],1)],1)],1),_c('v-row',[_c('v-col',[_vm._v(" Hjemme ")])],1),_c('v-row',[_c('v-col',[_vm._v(" Træk og opsummer fra grupper og sektioner ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }